import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const LogoMarquee = ({ items, reverse = false, duration = 30 }) => {
  const reduceMotion = useReducedMotion();
  const loop = [...items, ...items];

  return (
    <div className="flex overflow-x-auto md:overflow-hidden">
      <motion.div
        className="flex space-x-8 py-6"
        animate={reduceMotion ? undefined : { x: reverse ? [-1600, 0] : [0, -1600] }}
        transition={
          reduceMotion
            ? undefined
            : {
                x: {
                  repeat: Infinity,
                  repeatType: 'loop',
                  duration,
                  ease: 'linear',
                },
              }
        }
      >
        {loop.map((item, index) => (
          <div
            key={`${item.name}-${index}`}
            className="flex-shrink-0 w-44 h-28 bg-white rounded-xl border border-gray-200 flex items-center justify-center px-4 hover:border-[#398024] hover:shadow-lg transition-all duration-300"
          >
            {item.logo ? (
              <img
                src={item.logo}
                alt={`${item.name} logo`}
                width={140}
                height={72}
                loading="lazy"
                className="max-h-16 max-w-full object-contain"
              />
            ) : (
              <span className="text-gray-600 font-bold text-xs text-center">{item.name}</span>
            )}
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default LogoMarquee;
